import { addStoreLocaleByCookie } from 'lib/storeLocale/client'
import { Actions as ClipboardActions } from 'actions/utility/clipboard'
import { isAuthenticated } from 'selectors/user/session'
const { SITE_URL } = process.env
export const editCollection = (editUrl) => {
  if (!isAuthenticated) {
    const redirectURL = encodeURI(editUrl)
    const location = addStoreLocaleByCookie(`/authentication?redirect_url=${redirectURL}`)
    window.location = location
  } else {
    const location = addStoreLocaleByCookie(editUrl)
    window.location = location
  }
}
export const reorderCollection = (reorderUrl) => {
  if (!isAuthenticated) {
    const redirectURL = encodeURI(reorderUrl)
    const location = addStoreLocaleByCookie(`/authentication?redirect_url=${redirectURL}`)
    window.location = location
  } else {
    const location = addStoreLocaleByCookie(reorderUrl)
    window.location = location
  }
}
export const exportEmail = (exportEmailsUrl) => {
  if (!isAuthenticated) {
    const redirectURL = encodeURI(exportEmailsUrl)
    const location = addStoreLocaleByCookie(`/authentication?redirect_url=${redirectURL}`)
    window.location = location
  } else {
    const location = addStoreLocaleByCookie(exportEmailsUrl)
    window.location = location
  }
}
export const iosVIR = (iosVirUrl) => {
  ClipboardActions.COPY_TEXT(`${SITE_URL || ''}${iosVirUrl}`)
}
